// extracted by mini-css-extract-plugin
export var Logo = "t_X";
export var angleSvg = "t_Z";
export var aniBgLoading = "t_f";
export var aniSpin = "t_d";
export var isInverse = "t_0";
export var rightSvg = "t_Y";